import { merchantApi } from '@/config/axios'

/** 供应商端 API（与 merchant 相同 baseURL，走 /supplier-api） */
export const supplierApi = merchantApi

export function supplierLogin(data: { username: string; password: string }) {
  return supplierApi.post({ url: '/supplier-api/auth/login', data })
}

export function supplierLogout() {
  return supplierApi.post({ url: '/supplier-api/auth/logout' })
}

export function getSupplierInfo() {
  return supplierApi.get({ url: '/supplier-api/auth/info' })
}

export function updateSupplierPassword(data: { oldPassword: string; newPassword: string }) {
  return supplierApi.put({ url: '/supplier-api/auth/update-password', data })
}

export function getSupplierDraftPage(params: any) {
  return supplierApi.get({ url: '/supplier-api/product/pool-draft/page', params })
}

export function getSupplierDraft(id: number) {
  return supplierApi.get({ url: '/supplier-api/product/pool-draft/get', params: { id } })
}

export function saveSupplierDraft(data: any) {
  return supplierApi.post({ url: '/supplier-api/product/pool-draft/save', data })
}

export function submitSupplierDraft(data: any) {
  return supplierApi.post({ url: '/supplier-api/product/pool-draft/submit', data })
}

export function getSupplierOrderPage(params: any) {
  return supplierApi.get({ url: '/supplier-api/trade/order/page', params })
}

export function getSupplierOrderDetail(id: number) {
  return supplierApi.get({ url: '/supplier-api/trade/order/get-detail', params: { id } })
}

export function deliverySupplierOrder(data: { id: number; logisticsId: number; logisticsNo: string }) {
  return supplierApi.put({ url: '/supplier-api/trade/order/delivery', data })
}

export function getSupplierExpressList() {
  return supplierApi.get({ url: '/supplier-api/trade/order/express-list' })
}

/** 履约台账（只读对账报表）：默认已发货+已完成 */
export function getSupplierFulfillmentLedgerPage(params: any) {
  return supplierApi.get({ url: '/supplier-api/trade/fulfillment-ledger/page', params })
}

/** 挂供往来预估（阶段 A · 非结算） */
export function getSupplierSettlePreviewSummary(params: any) {
  return supplierApi.get({ url: '/supplier-api/trade/supplier-settle-preview/summary', params })
}

export function getSupplierSettlePreviewPage(params: any) {
  return supplierApi.get({ url: '/supplier-api/trade/supplier-settle-preview/page', params })
}
